export default "__VITE_ASSET__ASv1cHmY__"